module.exports = __webpack_public_path__ + "static/img/1-1-4.4a2f0902.jpg";